import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import type { TableFilter } from '@pbt/pbt-ui-components'

import CheckboxListFilter, {
  type CheckboxListFilterProps,
} from '~/components/common/filters/CheckboxListFilter'
import { KibSearchableSelect } from '~/components/common/filters/KibSearchableSelect'
import FeatureToggle from '~/constants/featureToggle'
import { InventoryCategoryName } from '~/constants/inventoryCategory'
import {
  getFeatureToggle,
  getInventoryCategory,
} from '~/store/reducers/constants'

export interface CategoryFilterProps extends CheckboxListFilterProps {
  selectedCategoryFilter?: TableFilter
}

const CategoryFilter = ({
  selectedCategoryFilter,
  ...props
}: CategoryFilterProps) => {
  const { t } = useTranslation('Common')
  const InventoryCategory = useSelector(getInventoryCategory)

  const isFoodCatalogEnabled = useSelector(
    getFeatureToggle(FeatureToggle.FOOD_CATALOG),
  )
  const isInventoryKibFiltersEnabled = useSelector(
    getFeatureToggle(FeatureToggle.INVENTORY_KIB_FILTERS),
  )

  const selectedValues: string[] = Array.isArray(selectedCategoryFilter?.value)
    ? selectedCategoryFilter.value.map(String)
    : []

  const allowedFilters = InventoryCategory.filter(
    (category) =>
      isFoodCatalogEnabled || category.name !== InventoryCategoryName.VET_DIET,
  )

  if (!isInventoryKibFiltersEnabled) {
    return <CheckboxListFilter items={allowedFilters} {...props} />
  }

  return (
    <KibSearchableSelect
      options={allowedFilters}
      placeholder={t('Common:CATEGORY')}
      selectedValues={selectedValues}
      onChange={props.onChange}
    />
  )
}

export default CategoryFilter
